import { render, staticRenderFns } from "./TabletLayout.vue?vue&type=template&id=54b28b16&scoped=true"
import script from "./TabletLayout.vue?vue&type=script&lang=js"
export * from "./TabletLayout.vue?vue&type=script&lang=js"
import style0 from "./TabletLayout.vue?vue&type=style&index=0&id=54b28b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b28b16",
  null
  
)

export default component.exports